var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResponsiveWebDesignLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iphone"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A171B",
    d: "M464.068,111.809H52.56v0.001c-6.471,0-11.766,5.294-11.766,11.766v268.849 c0,6.472,5.295,11.767,11.766,11.767h411.508c6.471,0,11.767-5.295,11.767-11.767v-268.85 C475.834,117.104,470.538,111.809,464.068,111.809z M181.256,324.081l65.103,22.27l-72.458,26.371l-52.699-144.802l88.421-32.18 l-37.518,109.679C169.489,313.064,173.606,321.465,181.256,324.081z M221.419,316.619c0.734-2.145,3.074-3.296,5.218-2.562 l14.797,5.062c2.153,0.736,3.297,3.079,2.563,5.224c-0.735,2.149-3.073,3.299-5.227,2.562l-14.797-5.062 C221.829,321.109,220.684,318.769,221.419,316.619z M197.439,288.393l44.187-129.175l82.805,28.325l-44.187,129.175L197.439,288.393 z M343.174,189.792c2.615-7.647-1.503-16.047-9.15-18.664l-29.27-10.012l37.992-13.827l52.7,144.802l-99.675,36.276L343.174,189.792 z M61.288,132.123h264.495l-51.252,18.654l-30.433-10.41c-7.649-2.616-16.049,1.502-18.665,9.149l-7.475,21.851l-102.67,37.368 c-11.562,4.206-17.522,16.987-13.312,28.547l51.174,140.6c0.805,2.215,1.927,4.222,3.292,5.993H61.288V132.123z M455.339,383.876 H201.83l199.508-72.612c11.56-4.211,17.521-16.992,13.312-28.554l-51.177-140.602c-1.494-4.104-4.071-7.497-7.286-9.985h99.152 V383.876z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsiveWebDesignLogo);
export default __webpack_public_path__ + "static/media/Responsive_Web_Design_Logo.185f3591d7581dcb903259e84ac9d121.svg";
export { ForwardRef as ReactComponent };